/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_AttributesInputs */

const en_nav_attributes = /** @type {(inputs: Nav_AttributesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attributes`)
};

/**
* | output |
* | --- |
* | "Attributes" |
*
* @param {Nav_AttributesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_attributes = /** @type {((inputs?: Nav_AttributesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_AttributesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_attributes(inputs)
});